<script setup lang="ts">
import { onMounted } from 'vue';

import { useRecipeStore } from '@apps/main/new-desktop/core/stores/recipe/recipeStore';

import { AppModal } from '@libs/ui';

import { ActivityDetailsModalType } from '../../models';
import TicketsSelectorDesktopLoader from '../loaders/TicketsSelectorDesktopLoader.vue';
import {
  useActivityDetailsModalsStore,
  useActivityDetailsStore,
} from '../../stores';
import { useActivityDetailsTicketsStore } from '../../stores/activityDetailsTicketsStore';

import TicketsSelectorDesktop from './TicketsSelectorDesktop.vue';

interface TicketsSelectorModalEmit {
  (event: 'close'): void;
  (event: 'select-tickets'): void;
}
const emit = defineEmits<TicketsSelectorModalEmit>();

const activityDetailsModalsStore = useActivityDetailsModalsStore();
const activityDetailsStore = useActivityDetailsStore();
const activityDetailsTicketsStore = useActivityDetailsTicketsStore();
const recipeStore = useRecipeStore();
function handleSelectTicket(): void {
  activityDetailsTicketsStore.selectTicket();
  emit('select-tickets');
}

onMounted(() => {
  const initialTickets = recipeStore.selectedActivityTickets.map((ticket) => ({
    code: ticket.code,
    ageRangeId: ticket.ageRangeId,
    quantity: ticket.quantity,
    dateOffset: ticket.dateOffset,
    timeSlotId: ticket.timeSlotId,
  }));
  activityDetailsTicketsStore.setInitialTickets(initialTickets);
});
</script>

<template>
  <AppModal
    v-if="
      activityDetailsModalsStore.activityDetailsModalType ===
      ActivityDetailsModalType.TicketsSelection
    "
    @close="emit('close')"
  >
    <TicketsSelectorDesktopLoader
      v-if="activityDetailsStore.isLoadingTickets"
      :activity-details-footer-data="
        activityDetailsTicketsStore.activityDetailsFooterData
      "
      @close="emit('close')"
    />

    <TicketsSelectorDesktop
      v-else
      :activity-details-footer-data="
        activityDetailsTicketsStore.activityDetailsFooterData
      "
      @close="emit('close')"
      @select-tickets="handleSelectTicket"
    />
  </AppModal>
</template>
